import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
import CompStuPrescribeDataFunc from "@/pcomponents/common/content/edu/comp_stu_prescribe/func/data_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"comp_stu_prescribe",
    list_id:"comp_stu_prescribe_list",
    x_column_list_arr:[
      {"key":"a_date","name":"요청일","width":"100","is_show":"1"},
      {"key":"a_mcomp_name","name":"학원","width":"100","is_show":"1"},
      {"key":"a_stu_name","name":"학생","width":"100","is_show":"1"},
      {"key":"a_subject","name":"과목","width":"100","is_show":"1"},
      // {"key":"a_state","name":"상태","width":"100","is_show":"1"},
      // {"key":"a_stu_grade_str","name":"학년","width":"100","is_show":"1"},
      {"key":"a_title","name":"제목","width":"200","is_show":"1"},
      {"key":"a_writer","name":"작성자","width":"80","is_show":"1"},
      {"key":"a_prescriber","name":"처방자","width":"80","is_show":"1"},
      {"key":"row_view_manage","name":"관리","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':30,
      'order_id':'',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.select_arr.a_state=CompStuPrescribeDataFunc.select_state_arr;

  return xColumnArr;
};

export default getXcolumnJson;